var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import { string, node, elementType } from 'prop-types';
import { media } from '@gympass/yoga-helpers';
import Box from '../../Box';
import Logo from './Logo';
var StyledHeader = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var header = _ref.theme.yoga.components.header;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    padding: 0 ", "px;\n    height: ", "px;\n\n    ", "\n  "])), header.padding.xxs, header.height.xxs, media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      padding: 0 ", "px;\n      height: ", "px;\n    "])), header.padding.lg, header.height.lg));
});

var Header = function Header(_ref2) {
  var link = _ref2.link,
      children = _ref2.children,
      logo = _ref2.logo;
  return /*#__PURE__*/React.createElement(StyledHeader, {
    as: "header",
    d: "flex",
    elevation: "medium",
    bgColor: "white",
    alignItems: "center",
    w: "100%"
  }, link ? /*#__PURE__*/React.createElement("a", {
    href: link
  }, /*#__PURE__*/React.createElement(Logo, {
    customLogo: logo
  })) : /*#__PURE__*/React.createElement(Logo, {
    customLogo: logo
  }), children);
};

Header.propTypes = {
  /** Use link to redirect clicking on the Gympass' logo */
  link: string,

  /** Use children to add whatever you want inside the header */
  children: node,

  /** Use logo to change headers image */
  logo: elementType
};
Header.defaultProps = {
  link: null,
  children: null,
  logo: null
};
export default Header;